"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnglePerLengthUnitSchema = void 0;
const zod_1 = require("zod");
exports.AnglePerLengthUnitSchema = zod_1.z.enum(['deg_m']);
exports.default = exports.AnglePerLengthUnitSchema;
//# sourceMappingURL=AnglePerLengthUnitSchema.js.map